import { action, observable } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from "react";
import { removeFromArray } from '../../utils/array.utils';
import { IconDefs } from './iconDefs';
var s = observable({
    activeIcons: [],
    get uniqueIcons() {
        var result = {};
        s.activeIcons.forEach(function (i) {
            var _a;
            var key = i[0];
            var variant = i[1];
            if (!result[key])
                result[key] = [];
            var symbolFc = (_a = IconDefs[key]) === null || _a === void 0 ? void 0 : _a[variant];
            if (!symbolFc || result[key].includes(symbolFc))
                return;
            result[key].push(symbolFc);
        });
        return result;
    },
});
export var activateIcon = action(function (name, variant) {
    if (s.activeIcons.find(function (i) { return i[0] === name && i[1] === variant; }))
        return;
    s.activeIcons.push([name, variant]);
    return function () { return removeFromArray(s.activeIcons, name); };
});
var style = {
    position: 'fixed',
    top: -24,
    left: -24,
    width: 24,
    height: 24,
    overflow: 'hidden',
    opacity: 0,
};
var Symbols = function () {
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "Symbols", style: style },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 24 24" },
                React.createElement("defs", null, Object.values(s.uniqueIcons).map(function (syms) { return syms.map(function (sym) { return sym(); }); }))))); } });
};
export default Symbols;
